import {
  createStyles,
  Group,
  Paper,
  SegmentedControl,
  Stack,
  Text,
} from '@mantine/core';
import React, { useState } from 'react';

import { OrderType } from '@portals/api/partners';
import { useGenericContext } from '@portals/framework';
import { TableDetailsPanel } from '@portals/table';

import { OrderProductsBreakdown } from './order-products-breakdown/OrderProductsBreakdown';
import { OrderProductsSummary } from './order-products-summary/OrderProductsSummary';
import { PurchasedProductDetailsPanel } from '../../../pages/store-management/pages/purchased-products/PurchasedProductDetailsPanel';

export function OrderProductsCard() {
  const { classes } = useStyles();
  const [viewType, setViewType] = useState<'summary' | 'breakdown'>('summary');
  const [purchasedProductId, setPurchasedProductId] = useState<string>(null);
  const order = useGenericContext<OrderType>();

  const onSelectProduct = (productId: string) =>
    setPurchasedProductId(purchasedProductId === productId ? null : productId);

  return (
    <>
      {purchasedProductId ? (
        <TableDetailsPanel
          key={purchasedProductId}
          width={400}
          type="inner"
          onClose={() => setPurchasedProductId(null)}
          className={classes.sidePanelContainer}
        >
          <PurchasedProductDetailsPanel
            purchasedProductId={purchasedProductId}
            onClose={() => setPurchasedProductId(null)}
          />
        </TableDetailsPanel>
      ) : null}

      <Paper withBorder p="xl" radius="md" pb={0}>
        <Stack>
          <Group align="center" position="apart">
            <Text size="md" color="gray.8">
              Products
            </Text>

            {order.payment_status === 'paid' ? (
              <SegmentedControl
                w={230}
                size="xs"
                data={[
                  { label: 'Summary', value: 'summary' },
                  { label: 'Breakdown', value: 'breakdown' },
                ]}
                value={viewType}
                onChange={(viewType: 'summary' | 'breakdown') =>
                  setViewType(viewType)
                }
              />
            ) : null}
          </Group>

          {viewType === 'summary' ? (
            <OrderProductsSummary />
          ) : (
            <OrderProductsBreakdown
              onSelectPurchasedProductId={onSelectProduct}
              selectedPurchasedProductId={purchasedProductId}
            />
          )}
        </Stack>
      </Paper>
    </>
  );
}

const useStyles = createStyles((theme) => ({
  sidePanelContainer: {
    border: 'none',
  },
}));
